import * as StringValidation from '../../libs/validation/stringRegex'
import * as Constants from '../../costants'

import { Place } from '../../components/address/AutoSelectionAddress'

import { isValidPrivacy } from '../../components/privacy/BasicPrivacy'

import { authFetch } from '../../libs/cookie/Cookie'

import { CONNECTION_ERROR } from '../../components/pagination/PageOneValidation'

import { UserType } from '../../libs/user/User' 

export async function stepTwoValidation (
    sinistriPrecedenti: boolean | undefined,
    polizzaGiaAttiva: boolean | undefined,
    dataScadenza: string | undefined,

    metri_quadri: number | undefined,
    tipo_uso: string | undefined,
    tipo_immobile: string | undefined,
    numero_piani: number | undefined,
    piano_abitazione: number | undefined,
    anno_costruzione: string | undefined,
    anno_ristrutturazione: number | undefined,
    
    indirizzo: string | undefined,
    is_manual_address: boolean | undefined,

    materiale: string | undefined,
    altri_materiali: string | undefined,
    stato_abitazione: string | undefined,
    
    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (sinistriPrecedenti === undefined) {
        error = 'SINISTRI'
    }

    else if (StringValidation.isEmpty( materiale )) {
        error = 'MATERIALE'
    }
    else if ( materiale === 'altro' && StringValidation.isEmpty( altri_materiali ) ) {
        error = 'ALTRI_MATERIALI'
    }
    else if (StringValidation.isEmpty( stato_abitazione )) {
        error = 'STATO_ABITAZIONE'
    }
    
    else {
        const abortController = new AbortController()

        if (is_manual_address !== true) {
            await authFetch (
                Constants.ADDRESS_SEARCH_URL,
                {
                    method: 'post',
                    body: JSON.stringify( indirizzo ),
                    signal: abortController?.signal
                },
                manageExpiredSessionsCallBack
            ).then( (res: any) => {
                let palces = (res.placeList as Array<any>)
                
                let hearAddress = indirizzo
                hearAddress = hearAddress?.replace("(", "").replace(")", "")

                if (palces === undefined || !palces.some ( (c: Place) => c.description.toUpperCase() === hearAddress )) {
                    console.log (
                        hearAddress,
                        palces
                    )
                    error = 'BUILD_ADDRESS_NOT_FOUND'    
                }
            }).catch( async (err) => {
                error = 'BUILD_ADDRESS_NOT_FOUND'
            })
        }

        if (error === undefined) {
            await authFetch (
                Constants.STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        sinistriPrecedenti: sinistriPrecedenti ?? null,
                        polizzaGiaAttiva: polizzaGiaAttiva ?? null,
                        dataScadenza: dataScadenza ?? null,

                        metri_quadri: metri_quadri ?? null,
                        tipo_uso: tipo_uso ?? null,
                        tipo_immobile: tipo_immobile ?? null,
                        numero_piani: numero_piani ?? null,
                        piano_abitazione: piano_abitazione ?? null,

                        anno_costruzione: anno_costruzione ?? null,
                        anno_ristrutturazione: anno_ristrutturazione ?? null,

                        indirizzo: indirizzo ?? null,
                        materiale: materiale ?? null,
                        altri_materiali: altri_materiali ?? null,
                        
                        stato_abitazione: stato_abitazione ?? null
                    })
                },
                manageExpiredSessionsCallBack,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }
    }

    printErrorCallBack (error)

    return error
}


export async function stepTreeValidation (
    abitazione_principale: boolean | undefined,
    sede_lavoro: boolean | undefined,
    vincolato_belle_arti: boolean | undefined,
    valore_perizia: number | undefined,
    assicurazione_incendio: boolean | undefined,
    assicurazione_furto: boolean | undefined,
    valore_beni: number | undefined,
    
    user: UserType | undefined,
    noMotorPrivacy: any,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (abitazione_principale === undefined) {
        error = 'ABITAZIONE_PRINCIPALE'
    }
    else if (sede_lavoro === undefined) {
        error = 'SEDE_LAVORO'
    }
    else if (vincolato_belle_arti === undefined) {
        error = 'VINCOLATO_BELLE_ARTI'
    }
    else if (assicurazione_incendio === undefined) {
        error = 'ASSICURAZIONE_INCENDIO'
    }
    else if (assicurazione_furto === undefined) {
        error = 'ASSICURAZIONE_FURTO'
    }
    else if ((assicurazione_incendio === true || assicurazione_furto === true) && valore_beni === undefined) {
        error = 'VALORE_BENI'
    }
    else if (isValidPrivacy( noMotorPrivacy, user !== undefined)) {
        error = 'PRIVACY'
    }

    else {
        await authFetch (
            Constants.STEP_3_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    abitazione_principale: abitazione_principale ?? null,
                    sede_lavoro: sede_lavoro ?? null,
                    vincolato_belle_arti: vincolato_belle_arti ?? null,
                    valore_perizia: valore_perizia ?? null,
                    assicurazione_incendio: assicurazione_incendio ?? null,
                    assicurazione_furto: assicurazione_furto ?? null,
                    valore_beni: valore_beni ?? null,
                    
                    privacy: noMotorPrivacy ?? null,
                    isLogged: (user !== undefined)
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}